import { useCallback } from 'react'

import { QuickStartStep } from '../enums/quickStartStep'
import {
  isOrganizationAccountInfoComplete,
  OrganizationAccountInfoFields,
} from '../utils/isOrganizationAccountInfoComplete'
import { useQuickStartProgress } from './useQuickStartProgress'

export const useMarkAccountStepDone = () => {
  const { markStepDone } = useQuickStartProgress()

  return useCallback(
    (organizationAccountInfo: OrganizationAccountInfoFields) => {
      if (isOrganizationAccountInfoComplete({ organizationAccountInfo })) {
        markStepDone(QuickStartStep.Account)
      }
    },
    [markStepDone],
  )
}
